import { render } from "./Singup.vue?vue&type=template&id=833d6330&scoped=true"
import script from "./Singup.vue?vue&type=script&lang=js"
export * from "./Singup.vue?vue&type=script&lang=js"

import "./Singup.vue?vue&type=style&index=0&id=833d6330&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-833d6330"

export default script